/**
 * Which file-share dialog is open (Task 7.16): S7's own zustand slot, next to the S3 dialog store. The tree menu, the
 * files-mode toolbar, the empty state and the row menu open a dialog through `openShareDialog`; `FileShareDialogsHost`
 * (mounted once in App.tsx) renders the open one. Type-only imports keep it free of workspace / store cycles.
 */
import { create } from 'zustand';
import type { DirectoryRef, FileRef, FileShareProtocolState, ShareRef } from '../../../../types/azureStorageFiles';
import type { ShareActionSource } from './namedShareActions';

export type ShareDialogKind =
  | 'create-share' | 'open-share-by-name' | 'share-quota' | 'share-snapshots' | 'delete-share' | 'delete-snapshot'
  | 'mount-command' | 'properties';
export type ShareDialogRequest = {
  kind: ShareDialogKind;
  connectionId: string;
  /** The share (a snapshot share for `delete-snapshot`), or the directory / file whose properties are shown. */
  resource?: ShareRef | DirectoryRef | FileRef;
  source: ShareActionSource;
  /** Set when a tab opened it: the dialog closes with that tab. */
  tabId?: string;
  /** The share's protocol when the opener knows it (a share node, the files tab); else the dialog reads it where it needs it. */
  protocol?: FileShareProtocolState;
};

type State = { request: ShareDialogRequest | null; open: (request: ShareDialogRequest) => void; close: () => void };
export const useFileDialogStore = create<State>((set) => ({ request: null, open: (request) => set({ request }), close: () => set({ request: null }) }));

export function openShareDialog(request: ShareDialogRequest): void {
  useFileDialogStore.getState().open(request);
}

/** A released tab takes its open dialog with it. */
export function closeFileDialogsForTab(tabId: string): void {
  if (useFileDialogStore.getState().request?.tabId === tabId) useFileDialogStore.getState().close();
}
